<import from="../../value-converters/currency-format"></import>

<containerless></containerless>

<div>
  <div if.bind="acceptsCreditCardPayments" class="one-half">
    <p class="title">Pay by credit card</p>
    <span if.bind="alertShow" class="alert alert-${alertType}" role="alert">
      <ul>
        <li repeat.for="error of paymentErrors">${error.Message}</li>
      </ul>
    </span>

    <section if.bind="!isConfirmPayment">
      <label for="name-on-card">Name on card</label>
      <input
        type="text"
        name="name-on-card"
        class="name-on-card"
        value.bind="cardName & validate"
      />
      <label for="card-number">Card number</label>
      <input
        type="text"
        name="card-number"
        class="card-number"
        maxlength="16"
        value.bind="cardNumber & validate"
      />
      <span class="grouped">
        <span class="group two-thirds">
          <label for="expires">Expires on</label>
          <select name="month" value.bind="cardExpiryMonth & validate">
            <option
              value="${month.index}"
              repeat.for="month of expiryMonthArray"
            >
              ${month.name}
            </option>
          </select>
          <select name="year" value.bind="cardExpiryYear & validate">
            <option value="${year.index}" repeat.for="year of expiryYearArray">
              ${year.name}
            </option>
          </select>
        </span>
        <span class="group one-third">
          <div class="tooltip">
            <div class="tooltip-content">
              <h4>cvn help</h4>
              <p>your 3 or 4 digit credit card verification number</p>
            </div>
          </div>
          <label for="csv">CVN</label>
          <input
            type="text"
            name="csv"
            class="csv"
            maxlength="4"
            value.bind="cardCvn & validate"
          />
        </span>
      </span>

      <a id="pay-now" class="button" click.trigger="reviewPayment()"
        >Review and Pay</a
      >
      <input
        id="submit"
        class="hidden button"
        disabled
        type="submit"
        value="submit"
      />
      <p id="form-message">The following credit card surcharges apply:</p>
      <p>
        Visa / MasterCard Debit 0.60% <br />
        Visa / MasterCard Credit 1.15% <br />
        Amex Credit 1.60%
      </p>
    </section>
    <section if.bind="isConfirmPayment">
      <label for="name-on-card">Name on card</label>
      ${cardName}
      <label for="card-number">Card number</label>
      ${cardNumber}
      <span class="grouped">
        <span class="group two-thirds">
          <label for="expires">Expires on</label>
          ${cardExpiryMonth} / ${cardExpiryYear}
        </span>
        <span class="group one-third">
          <label for="csv">CVN</label>
          ${cardCvn}
        </span>
      </span>
      <label for="surcharge">Surcharge %</label>
      ${surchargePercentage}%
      <label for="surcharge-amount">Surcharge Amount</label>
      ${surchargeAmount | currencyFormat:'($0,0.00)'}
      <label for="total-amount-inc-surcharge"
        >Total Amount (inc. surcharge)</label
      >
      <strong>${totalIncludingSurcharge | currencyFormat:'($0,0.00)'}</strong>
      <br />
      <a id="pay-now" class="button" click.trigger="addPayment()">Back</a>
      <a id="pay-now" class="button" click.trigger="processPayment()"
        >Pay Now</a
      >
      <p id="form-message">The following credit card surcharges apply:</p>
      <p>
        Visa / MasterCard Debit 0.60% <br />
        Visa / MasterCard Credit 1.15% <br />
        Amex Credit 1.60%
      </p>
    </section>
  </div>
  <div
    if.bind="acceptsCreditCardPayments && acceptsPremiumFunderPayments"
    class="divider"
  >
    <div class="or">or</div>
  </div>
  <div if.bind="acceptsPremiumFunderPayments" class="one-half top">
    <p class="title">Pay by premium funder</p>
    <label for="submit" if.bind="appService.isFunderEnabled">
      Pay your premium via monthly installment, apply for funding now!</label
    >
    <label
      for="submit"
      if.bind="!appService.isFunderEnabled"
      class="validation-message-container"
    >
      Only amounts less than $15,000.00 can be funded.</label
    >
    <premium-funder if.bind="appService.isFunderEnabled"></premium-funder>
    <p id="form-message"></p>
  </div>
</div>

<ia-modal
  showing.bind="showPayNowModal || showVerifyModal"
  type="none"
  click-close.bind="false"
  key-close.bind="false"
>
  <template au-slot>
    <div>
      <h5>${modalMessage}</h5>
      <p>Do not refresh, click back, or exit the browser!</p>
    </div>
  </template>
</ia-modal>
